import React, { useEffect, useState } from 'react';
import { Row, Col, Space, Card, Typography, Spin } from 'antd';
import InspectorKatipSummaryCard from '../components/InspectorKatipSummaryCard';
import { Link } from 'react-router-dom';
import { MessageMultiple01Icon } from 'hugeicons-react';
import { TapeMeasureIcon } from 'hugeicons-react';
import { Calendar03Icon } from 'hugeicons-react';
import { countPendingMeasuringInstrumentInspectors } from '../../measuring-instrument-inspectors/services/measuring-instrument-inspectorService';
import { listMyInspectionAppointmentsAll } from '../../inspection-appointments/services/inspection-appointmentService';
import dayjs from 'dayjs';
import { apiFetch } from 'http-common';
import ReminderSummaryCards from 'components/Reminders/ReminderSummaryCards';
import PlanDeviceReadinessCard from 'components/Dashboard/PlanDeviceReadinessCard';
import { hasRole } from '../../../utils';

export default function InspectorDashboard() {
  const { Title } = Typography;
  const isInspector = hasRole('INSPECTOR');
  const [pendingDevicesCount, setPendingDevicesCount] = useState(0);
  const [upcomingProposalsCount, setUpcomingProposalsCount] = useState(0);
  const [upcomingLoading, setUpcomingLoading] = useState(false);
  const [openTicketCount, setOpenTicketCount] = useState<number | null>(null);
  const extractTotal = (response: any): number => {
    if (!response || typeof response !== 'object') {
      return 0;
    }
    if (typeof response.totalElements === 'number') {
      return response.totalElements;
    }
    if (Array.isArray(response.content)) {
      return response.content.length;
    }
    if (Array.isArray(response)) {
      return response.length;
    }
    return 0;
  };
  useEffect(() => {
    let ignore = false;
    const loadCount = async () => {
      try {
        const response = await countPendingMeasuringInstrumentInspectors("confirmedAt.specified=false&rejectedAt.specified=false");
        const numeric = typeof response === 'number' ? response : Number(response);
        const value = Number.isFinite(numeric) ? numeric : 0;
        if (!ignore) {
          setPendingDevicesCount(value);
        }
      } catch (error) {
        console.error('InspectorDashboard pending devices fetch failed:', error);
        if (!ignore) {
          setPendingDevicesCount(0);
        }
      }

      const ticketParams = new URLSearchParams({
        'status.equals': 'OPEN',
      });
      const ticketResponse = await apiFetch(`/accounts/me/tickets?${ticketParams.toString()}`);
      if (!ignore) {
        setOpenTicketCount(extractTotal(ticketResponse));
      }
    };
    loadCount();
    return () => {
      ignore = true;
    };
  }, []);

  useEffect(() => {
    let ignore = false;
    const loadUpcoming = async () => {
      try {
        setUpcomingLoading(true);
        const params = new URLSearchParams({
          'startDate.greaterThanOrEqual': dayjs().startOf('day').toISOString(),
          sort: 'startDate,ASC',
        });
        const response = await listMyInspectionAppointmentsAll(params.toString());
        if (ignore) return;
        const proposalIds = new Set<number>();
        (Array.isArray(response) ? response : []).forEach((appointment) => {
          const proposalId = appointment?.proposalId;
          if (proposalId != null) {
            const numericId = Number(proposalId);
            if (!Number.isNaN(numericId)) {
              proposalIds.add(numericId);
            }
          }
        });
        setUpcomingProposalsCount(proposalIds.size);
      } catch (error) {
        console.error('InspectorDashboard upcoming appointments fetch failed:', error);
        if (!ignore) {
          setUpcomingProposalsCount(0);
        }
      } finally {
        if (!ignore) {
          setUpcomingLoading(false);
        }
      }
    };
    loadUpcoming();
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <>
      <div style={{ padding: 24, minHeight: '90%', paddingTop: 0 }}>
        <Space direction='vertical' size={16} style={{ width: '100%' }}>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={6}>
              <Link to='/inspector/plan' style={{ display: 'block' }}>
                <Card bordered={false} hoverable className="dashboard-card dashboard-card-bg-dark" bodyStyle={{ padding: 10 }}>
                  <div className='dashboard-container'>
                    <Row justify='space-between' align='middle'>
                      <div className='card-value'>
                        {upcomingLoading ? <Spin size='small' /> : upcomingProposalsCount}
                      </div>
                      <Calendar03Icon size={32} color='white' />
                    </Row>
                    <div>
                      <Title className='mb-0' level={3} style={{ color: 'white', fontWeight: 'bold' }}>Görevlerim</Title>
                    </div>
                  </div>
                </Card>
              </Link>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <InspectorKatipSummaryCard />
            </Col>
            <Col xs={24} md={12} lg={6}>
              <Link to='/inspector/devices?tab=assignments' style={{ display: 'block' }}>
                <Card bordered={false} hoverable className="dashboard-card dashboard-card-bg-white" bodyStyle={{ padding: 10 }}>
                  <div className='dashboard-container'>
                    <Row justify='space-between' align='middle'>
                      <div className='card-value'>
                        {pendingDevicesCount}
                      </div>
                      <TapeMeasureIcon size={32} color='#001433' />
                    </Row>
                    <div>
                      <Title style={{ fontWeight: 'bold', color: '#001433' }} className='mb-0' level={3}>Onay Bekleyen Cihazlar</Title>
                    </div>
                  </div>
                </Card>
              </Link>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <Link to='/tickets' style={{ display: 'block' }}>
                <Card bordered={false} hoverable className="dashboard-card dashboard-card-bg-green" bodyStyle={{ padding: 10 }}>
                  <div className='dashboard-container'>
                    <Row justify='space-between' align='middle'>
                      <div className='card-value'>
                        {openTicketCount}
                      </div>
                      <MessageMultiple01Icon size={32} color='000000e0' />
                    </Row>
                    <div>
                      <Title style={{ fontWeight: 'bold' }} className='mb-0' level={3}>Açık Destek Talepleri</Title>
                    </div>
                  </div>
                </Card>
              </Link>
            </Col>
          </Row>
          <Row gutter={[16, 16]} role="region" aria-label="Kişisel Görev ve Cihaz Özeti">
            <Col xs={24} lg={isInspector ? 12 : 24} style={{ display: 'flex' }}>
              <ReminderSummaryCards
                title="Beklemede Olan Görevler"
                mode="me"
              />
            </Col>
            {isInspector && (
              <Col xs={24} lg={12} style={{ display: 'flex' }}>
                <PlanDeviceReadinessCard scope="me" />
              </Col>
            )}
          </Row>
        </Space>
      </div>
    </>
  );
}
